<template>
	<c-dialog ref="dialog" mode="slide" width="80vw"enable-flex @resolve="submitHandle">
		<!-- 商品范围信息 -->
		<div class="m-shelf-info flex">
			<p class="flex-grow ellipsis m-product-label">已选商品：<span class="m-product-name">{{productList.length}}个</span></p>
		</div>

		<!-- 暗拍/靓机选项卡切换 -->
		<div class="m-channel-tabs">
			<div
				v-for="tab in channelTypeTabs"
				:key="tab.value"
				:class="['m-tab-item', { 'm-tab-active': channelType === tab.value }]"
				@click="switchChannelTab(tab)"
			>
				{{tab.name}}
			</div>
		</div>

		<!-- 渠道多选下拉 + 汇总信息 -->
		<div class="m-channel-selector">
			<div class="m-channel-select-area">
				<label class="m-select-label">销售渠道：</label>
				<c-select v-model="selectedChannelIds" multiple :options="channelOptions" placeholder="请选择上架渠道" style="width: 360px;" @change="onChannelChange"></c-select>
			</div>
			<div class="m-summary-info">
				<span class="m-summary-item">台数 <b>{{productList.length}}</b></span>
				<span class="m-summary-item">总计售出价 <b>{{totalPrice}}</b></span>
			</div>
		</div>

		<!-- 商品表格（每行一个商品，渠道信息列内多行展示） -->
		<div class="m-shelf-table-area flex-column flex-grow">
			<c-table ref="list" :data="tableRows" height="grow" :paging="false" empty-text="请先选择渠道">
				<c-table-column label="商品名称" width="250">
					<template #default="{data}">
						<div class="m-product-info">
							<p class="m-product-name">
								<span v-if="data.level_name" class="m-level-tag" :class="levelClass(data.level_name)">{{data.level_name}}</span>
								<span>{{data.product_info || getProductText(data)}}</span>
							</p>
							<p class="m-product-code">背贴码：{{data.produce_unique_code}}</p>
							<p v-if="data.produce_imei" class="m-product-code">IMEI：{{data.produce_imei}}</p>
						</div>
					</template>
				</c-table-column>
				<c-table-column label="成本价" width="100">
					<template #default="{data}">
						<span>{{formatPrice(data.cost_price)}}</span>
					</template>
				</c-table-column>
				<c-table-column label="参考价" width="150">
					<template #default="{data}">
						<div v-if="(data.reference_price_list || []).length" class="m-ref-price-list">
							<p v-for="(ref, i) in data.reference_price_list" :key="i">{{ref.channel_name}}：{{formatPrice(ref.sale_price)}}</p>
						</div>
						<span v-else>-</span>
					</template>
				</c-table-column>
				<c-table-column label="推送渠道" width="500">
					<template #default="{data}">
						<div class="m-channel-lines">
							<div v-for="(ch, i) in data.channels" :key="i" class="m-ch-row">
								<span class="m-ch-name">{{ch.channel_name}}：</span>
								<c-input type="number" decimal="2" :range="[0, 99999999]" v-model="ch.new_sale_price" @input.native="onPriceInput" :disabled="ch.channel_publish_state == 2" placeholder="输入售价" append-text="元" :class="{'m-ch-price-input': true, 'm-ch-price-disabled': ch.channel_publish_state == 2}"></c-input>
                                <c-tooltip v-if="ch.channel_publish_state == 2" tip="当前渠道商品已发布，上架时不支持同时改价。如需调整请在商品列表页通过【改价】功能操作"><span class="m-ch-tip">!</span></c-tooltip>
                                <span v-if="ch.channel_publish_state != 2 && ch.new_sale_price && isBelowMinPrice(ch, data)" class="m-below-tip-inline">低于最低控价{{data.min_price}}元</span>
								<span class="m-settle-inline">预计结算价：{{getSettleText(ch, data)}}</span>
								<span class="m-help-wrap-inline">
									<c-tooltip tip="预计结算价按渠道结算规则测算，实际以结算账单为准">
										<span class="m-help">?</span>
									</c-tooltip>
								</span>
								<span class="m-settle-inline">预计消耗同售积分：{{getPointsText(ch)}}</span>
								<span class="m-help-wrap-inline">
									<c-tooltip tip="预计消耗同售积分按渠道积分阶梯测算，实际成交后从同售积分账户扣减">
										<span class="m-help">?</span>
									</c-tooltip>
								</span>
							</div>
						</div>
					</template>
				</c-table-column>
			</c-table>
		</div>
	</c-dialog>
</template>

<script>
	import { fetchSettleConfig, calcSettlePrice } from '@/components/public/settle.js';
	import { fetchPointsConfig, calcConsumePoints } from '@/components/public/points.js';

	export default {
		name: 'saleBatchShelfChannel',

		data() {
			return {
				/**暗拍/靓机选项卡（1暗拍渠道/2靓机渠道）*/
				channelTypeTabs: [{
					name: '靓机渠道',
					value: 2
				}, {
					name: '暗拍渠道',
					value: 1
				}],
				/**当前选项卡类型，默认靓机*/
				channelType: 2,
				productList: [],
				/**已选渠道ID列表（c-select 多选绑定值）*/
				selectedChannelIds: [],
				/**可选渠道池（当前选项卡类型下，c-select options 格式）*/
				channelOptions: [],
				/**可选渠道池原始数据（用于查找渠道信息）*/
				availableChannels: [],
				/**表格行数据（商品×渠道二维）*/
				tableRows: [],
				/**渠道结算公式集合*/
				settleConfigMap: {},
				/**渠道积分阶梯集合（{channel_id: [{price,points}]}），预计消耗积分测算依据*/
				pointsConfigMap: {},
				/**控价处置方式（1-严格拦截 2-仅提醒），与服务端 sale_price_control_mode 同一取值*/
				controlMode: 2,
				/**总计售出价（由 onPriceInput 从 table 内部状态计算）*/
				totalPrice: '0'
			}
		},

		computed: {
			/*********控价方式是否为严格拦截（拦截模式下前端直接挡回）**********/
			blockMode() {
				return this.controlMode == 1;
			},
			/*********已选渠道对象列表**********/
			selectedChannels() {
				return this.selectedChannelIds.map(id => this.availableChannels.find(ch => ch.channel_id == id)).filter(ch => ch);
			}
		},

		methods: {
			/*********打开弹框（批量商品）**********/
			open(data) {
				this.productList = (data && data.list) || [];
				this.channelType = 2;
				this.selectedChannelIds = [];
				this.settleConfigMap = {};
				this.pointsConfigMap = {};
				this.controlMode = 2;
				this.totalPrice = '0';
				this.loadSettleConfig();
				this.loadPointsConfig();
				this.loadPriceControlMode();
				this.loadAvailableChannels();
				this.$refs.dialog.open({
					title: '批量上架',
					buttonName: '确定上架'
				});
			},

			/*********切换暗拍/靓机选项卡**********/
			switchChannelTab(tab) {
				if (this.channelType === tab.value) return;
				this.channelType = tab.value;
				this.selectedChannelIds = [];
				this.loadAvailableChannels();
			},

			/*********渠道选择变更（c-select 多选值变化时重建表格行）**********/
			onChannelChange() {
				this.rebuildTableRows();
				this.updateTotalPrice();
			},

			/*********价格输入时更新总计（v-model 写入 c-table 内部状态，需从 getData 读取最新值）**********/
			onPriceInput() {
				this.$nextTick(() => {
					this.updateTotalPrice();
				});
			},

			/*********从 c-table 内部状态计算总计售出价**********/
			updateTotalPrice() {
				var rows = this.$refs.list ? this.$refs.list.getData() : this.tableRows;
				var total = 0;
				(rows || []).forEach(row => {
					(row.channels || []).forEach(ch => {
						var price = parseFloat(ch.new_sale_price || ch.sale_price);
						if (price > 0) total += price;
					});
				});
				this.totalPrice = total % 1 === 0 ? String(total) : total.toFixed(2);
			},

			/*********加载可选渠道池（调用后端接口获取商户授权渠道，不再从商品 channel_list 聚合）**********/
			loadAvailableChannels() {
				if (!this.productList.length) {
					this.availableChannels = [];
					this.channelOptions = [];
					this.rebuildTableRows();
					return;
				}
				this.request({
					url: '/sale/product/batchShelfChannel/list',
					data: {
						channel_type: this.channelType
					},
					success: data => {
						/**后端返回商户授权渠道池（channel_id, channel_name, is_dark_auction），前端自行与商品 channel_list 交叉*/
						this.availableChannels = (data || []).map(ch => {
							return {
								channel_id: ch.channel_id,
								channel_name: ch.channel_name,
								is_dark_auction: ch.is_dark_auction
							};
						});
						/**转换为 c-select options 格式（name/value）*/
						this.channelOptions = this.availableChannels.map(ch => {
							return {name: ch.channel_name, value: ch.channel_id};
						});
						this.rebuildTableRows();
					}
				});
			},

			/*********重建表格行（每行一个商品，渠道信息在列内多行展示）**********/
			rebuildTableRows() {
				var rows = [];
				this.productList.forEach(product => {
					var channels = [];
					this.selectedChannelIds.forEach(channelId => {
						var channelInfo = (product.channel_list || []).find(ch => ch.channel_id == channelId);
						if (!channelInfo) {
							channelInfo = {
								channel_id: channelId,
								channel_name: this.getChannelName(channelId),
								is_dark_auction: this.getChannelDarkFlag(channelId),
								channel_publish_state: null,
								listing_state: null,
								sync_state: null,
								sale_price: null
							};
						}
						channels.push({
							channel_id: channelInfo.channel_id,
							channel_name: channelInfo.channel_name,
							channel_publish_state: channelInfo.channel_publish_state,
							sale_price: channelInfo.sale_price === null || channelInfo.sale_price === undefined ? '' : channelInfo.sale_price,
							/**预填价格：只要渠道已有售价就填充（已发布渠道 disabled 不可改，未发布渠道可编辑）*/
							new_sale_price: (channelInfo.sale_price !== null && channelInfo.sale_price !== undefined && channelInfo.sale_price !== '')
								? channelInfo.sale_price
								: ''
						});
					});
					if (channels.length) {
						rows.push({
							id: product.id,
							produce_unique_code: product.produce_unique_code,
							produce_imei: product.produce_imei || '',
							product_info: product.product_info,
							level_name: product.level_name || '',
							brand_name: product.brand_name,
							model_name: product.model_name,
							memory_name: product.memory_name,
							color_name: product.color_name,
							cost_price: product.cost_price,
							reference_price_list: product.reference_price_list || [],
							min_price: product.min_price || '',
							channels: channels
						});
					}
				});
				this.tableRows = rows;
			},

			/*********获取渠道名称**********/
			getChannelName(channelId) {
				var ch = this.availableChannels.find(c => c.channel_id == channelId);
				return ch ? ch.channel_name : '';
			},

			/*********获取渠道暗拍标识**********/
			getChannelDarkFlag(channelId) {
				var ch = this.availableChannels.find(c => c.channel_id == channelId);
				return ch ? ch.is_dark_auction : 0;
			},

			/*********不可上架的原因（返回空表示可上架）**********/
			shelfExcludeReason(channel) {
				// 已在售无需重复上架
				if (channel.listing_state == 2) return '已在售';
				// 有在途同步任务
				if (channel.sync_state == 2) return '正在同步中';
				if (channel.sync_state == 1) return '已有同步任务待执行';
				// 状态不可上架
				if (channel.listing_state != 1 && channel.listing_state != 3 && channel.listing_state != null) return '渠道状态不可上架';
				// 已发布但无售价（数据异常）
				if (channel.channel_publish_state == 2 && !(channel.sale_price > 0)) return '已发布但未设置售价';
				return '';
			},

			/*********加载渠道结算公式**********/
			loadSettleConfig() {
				fetchSettleConfig(this, map => {
					this.settleConfigMap = map;
				});
			},

			/*********加载渠道积分阶梯（仅用于测算展示，不参与提交校验）**********/
			loadPointsConfig() {
				fetchPointsConfig(this, map => {
					this.pointsConfigMap = map;
				});
			},

			/*********加载控价处置方式（与单个上架弹框同源）**********/
			loadPriceControlMode() {
				this.request({
					url: '/sale/product/priceRatio/get',
					success: data => {
						this.controlMode = (data && data.control_mode) || 2;
					}
				});
			},

			/*********计算预计结算价**********/
			getSettleText(ch, row) {
				var price = ch.new_sale_price;
				if (!price) return '-';
				var settle = calcSettlePrice(this.settleConfigMap, ch.channel_id, row.brand_name, price);
				return settle === null ? '-' : '¥' + parseFloat(settle).toFixed(2);
			},

			/*********计算预计消耗积分（未填价、无阶梯或未命中档位时不给分数）**********/
			getPointsText(ch) {
				var price = ch.new_sale_price;
				if (!price) return '-';
				var points = calcConsumePoints(this.pointsConfigMap, ch.channel_id, price);
				return points === null ? '-' : points + '分';
			},

			/*********判断渠道售价是否低于最低控价**********/
			isBelowMinPrice(ch, row) {
				if (!row.min_price) return false;
				var price = parseFloat(ch.new_sale_price);
				if (!(price > 0)) return false;
				return price < parseFloat(row.min_price);
			},

			/*********等级tag样式映射**********/
			levelClass(level) {
				if (!level) return '';
				if (level.indexOf('充新') >= 0) return 'm-tag-good';
				if (level.indexOf('靓机') >= 0) return 'm-tag-blue';
				if (level.indexOf('小花') >= 0) return 'm-tag-purple';
				if (level.indexOf('大花') >= 0 || level.indexOf('外爆') >= 0) return 'm-tag-bad';
				return '';
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********获取表格当前数据（优先从 c-table 内部状态读取，确保拿到 v-model 写入的最新价格）**********/
			getCurrentRows() {
				if (this.$refs.list && typeof this.$refs.list.getData === 'function') {
					return this.$refs.list.getData() || [];
				}
				return this.tableRows;
			},
			
			/*********提交上架**********/
			submitHandle(stop, next) {
				stop();
				// 校验：至少选择一个渠道
				if (!this.selectedChannelIds.length) {
					this.$message({message: '请至少选择一个渠道', type: 'warn'});
					return;
				}
				// 校验：至少保留一个商品
				if (!this.productList.length) {
					this.$message({message: '请至少保留一个商品', type: 'warn'});
					return;
				}
				// 从 c-table 内部状态获取最新数据（v-model 写入的是 table 内部副本，不是 this.tableRows）
				var currentRows = this.getCurrentRows();
				// 校验：未发布渠道必须填写售价
				var missingPrice = [];
				currentRows.forEach(row => {
					(row.channels || []).forEach(ch => {
						if (ch.channel_publish_state != 2 && !(parseFloat(ch.new_sale_price) > 0)) {
							missingPrice.push(row.produce_unique_code + ' / ' + ch.channel_name);
						}
					});
				});
				if (missingPrice.length) {
					this.$message({message: '请填写以下未发布渠道的售价：' + missingPrice.slice(0, 3).join('、') + (missingPrice.length > 3 ? '等' : ''), type: 'warn'});
					return;
				}
			
				// 控价校验：统计破价条数（未发布渠道用填写价，已发布渠道用库中价）
				var belowItems = [];
				currentRows.forEach(row => {
					(row.channels || []).forEach(ch => {
						var checkPrice = ch.new_sale_price;
						if (this.isBelowMinPrice(ch, row) && parseFloat(checkPrice) > 0) {
							belowItems.push(row.produce_unique_code + ' / ' + ch.channel_name);
						}
					});
				});
				if (belowItems.length) {
					if (this.blockMode) {
						this.$message({message: belowItems[0] + ' 售价低于最低控价' + this.formatPrice(currentRows[0].min_price) + '，不可上架', type: 'warn'});
						return;
					}
					var _this = this;
					this.$confirm({
						message: '所选商品中有' + belowItems.length + '个渠道售价低于最低控价' + this.formatPrice(currentRows[0].min_price) + '，确认继续上架？',
						buttonName: '确认上架',
						cancelButton: true,
						resolve: () => {
							_this.doSubmit(next, currentRows);
						}
					});
					return;
				}
			
				this.doSubmit(next, currentRows);
			},

			/*********执行提交上架请求**********/
			doSubmit(next, currentRows) {
				// 组装提交数据（从 c-table 内部状态读取最新价格）
				var rows = currentRows || this.getCurrentRows();
				var productPrices = [];
				rows.forEach(row => {
					(row.channels || []).forEach(ch => {
						if (ch.channel_publish_state != 2 && parseFloat(ch.new_sale_price) > 0) {
							productPrices.push({
								product_id: row.id,
								channel_id: ch.channel_id,
								sale_price: parseFloat(ch.new_sale_price)
							});
						}
					});
				});

				this.request({
					url: '/sale/product/batchOnShelf',
					data: {
						product_ids: this.productList.map(item => item.id),
						channel_id_list: this.selectedChannelIds,
						product_prices: productPrices
					},
					loading: true,
					success: (data, msg) => {
						next();
						this.$emit('resolve');
						var failList = (data && data.fail_list) || [];
						if (failList.length) {
							this.$nextTick(() => {
								this.globalDialog('saleBatchShelfResult', {
									data: data
								});
							});
						} else {
							this.$message({message: msg || '上架提交成功', type: 'success'});
						}
						if (data && data.price_warn_count > 0) {
							this.$nextTick(() => {
								this.globalDialog('salePriceWarnResult', {
									data: data
								});
							});
						}
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	::v-deep .c-dialog-body {
		padding: 0 12px;
	}

	.m-shelf-info {
		padding: 12px 15px;
		margin-bottom: 12px;
		background: #f5f7fa;
		border-radius: 4px;
		font-size: 14px;
		gap: 12px;

		.m-product-label {
			color: #333;
		}

		.m-product-name {
			color: #1890ff;
		}
	}

	.m-shelf-tip {
		padding: 12px 0px;
		margin: 0 20px 10px;
		font-size: 14px;
		color: #e6a23c;
	}

	.m-channel-tabs {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0;
		margin: 0 auto 12px;
		padding: 4px;
		width: 320px;
		background: linear-gradient(135deg, #e6f7ff 0%, #f0f5ff 100%);
		border-radius: 24px;
		border: 1px solid #bae0ff;

		.m-tab-item {
			flex: 1;
			padding: 10px 32px;
			text-align: center;
			font-size: 14px;
			color: #666;
			cursor: pointer;
			border-radius: 20px;
			transition: all 0.3s;
			user-select: none;

			&:hover:not(.m-tab-active) {
				color: #1890ff;
			}

			&.m-tab-active {
				background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
				color: #fff;
				font-weight: 500;
				box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
			}
		}
	}

	.m-channel-selector {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px 20px;
		margin: 0 20px 10px;
		background: #fafafa;
		border-radius: 4px;
		border: 1px solid #e8e8e8;

		.m-channel-select-area {
			display: flex;
			align-items: center;
			gap: 12px;
			flex: 1;
			min-width: 0;

			.m-select-label {
				font-size: 14px;
				color: #333;
				font-weight: 500;
				flex-shrink: 0;
			}
		}

		.m-summary-info {
			display: flex;
			align-items: center;
			gap: 20px;
			flex-shrink: 0;
			margin-left: 20px;

			.m-summary-item {
				font-size: 14px;
				color: #666;
			
				b {
					color: #1890ff;
					font-weight: 600;
					margin-left: 4px;
					font-size: 15px;
				}
			}
		}
	}

	.m-shelf-table-area {
		margin: 0 20px 10px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: hidden;

		::v-deep .c-table-head th {
			font-size: 15px;
			font-weight: 600;
			color: #333;
		}

		::v-deep .c-table-body table tbody tr {
			border-bottom: 1px dashed #e8e8e8;
			font-size: 14px;

			&.is-selected {
				background-color: #fffbe6 !important;
			}
		}
	}

	.m-state-published {
		color: #909399;
		font-size: 12px;
		margin-left: 6px;
	}

	.m-ch-tip {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 14px;
		height: 14px;
		border: 1px solid #ed3f14;
		border-radius: 50%;
		color: #ed3f14;
		font-size: 11px;
		font-weight: bold;
		cursor: pointer;
		line-height: 1;
		flex-shrink: 0;
	}

	.m-state-unpublished {
		color: #e6a23c;
		font-size: 12px;
		margin-left: 6px;
	}

	.m-product-info {
		line-height: 24px;

		.m-product-name {
			display: flex;
			align-items: center;
			gap: 6px;
			font-size: 14px;
			color: #333;
			font-weight: 500;
		}

		.m-product-code {
			font-size: 13px;
			color: #666;
			margin-top: 2px;
		}

		.m-level-tag {
			display: inline-block;
			padding: 0 6px;
			height: 18px;
			line-height: 18px;
			font-size: 12px;
			border-radius: 2px;
			color: #fff;
			background: #2b7be4;

			&.m-tag-good {
				background: #19be6b;
			}
			&.m-tag-blue {
				background: #2b7be4;
			}
			&.m-tag-purple {
				background: #9254de;
			}
			&.m-tag-bad {
				background: #ed3f14;
			}
		}
	}

	.m-ref-price-list {
		p {
			line-height: 22px;
			font-size: 13px;
			color: #333;
		}
	}

	.m-channel-lines {
		padding: 6px 0;

		.m-ch-row {
			display: flex;
			align-items: center;
			gap: 6px;
			height: 32px;
			padding: 0 4px;
		}

		.m-ch-name {
			width: 90px;
			flex-shrink: 0;
			font-size: 13px;
			color: #333;
			text-align: right;
			display: inline-flex;
			align-items: center;
			justify-content: flex-end;
			gap: 3px;
		}

		.m-ch-price-input {
			width: 110px;
			flex-shrink: 0;

			::v-deep input {
				background-color: #fffbe6;
			}
		}

		// 已发布渠道售价输入框禁用态（灰色背景，视觉统一但不可编辑）
		.m-ch-price-disabled {
			::v-deep input {
				background-color: #f5f5f5 !important;
				color: #999;
				cursor: not-allowed;
			}
		}

		// 低于控价提示（行内紧凑展示）
		.m-below-tip-inline {
			font-size: 12px;
			color: #ed3f14;
			flex-shrink: 0;
		}

		// 预计结算价（行内紧凑展示）
		.m-settle-inline {
			font-size: 13px;
			color: #999;
			flex-shrink: 0;
		}

		.m-help-wrap-inline {
			display: inline-flex;
			align-items: center;
			flex-shrink: 0;
		}

		.m-help {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 14px;
			height: 14px;
			border: 1px solid #c0c4cc;
			border-radius: 50%;
			font-size: 10px;
			color: #909399;
			cursor: pointer;
		}
	}

	.m-biz-dark {
		color: #722ed1;
		font-size: 12px;
	}

	.m-biz-normal {
		color: #fa8c16;
		font-size: 12px;
	}
</style>
